import React from "react";
// import NavBar from "../components/NavBar/NavBar";

export default function Layout(props) {
  return (
    <div>
      <main>{props.children}</main>
    </div>
  );
}
